import { Injectable } from '@angular/core';
import { DownloadOrderInsightsEvent } from '@order/models/download-orders-event';
import { SeperatedColumn } from '@shared/models/seperated-columns';
import { DateService } from '../date.service';

@Injectable({
  providedIn: 'root',
})
export class OrderInsightsDownloadDtoService {
  /**
   *
   * @param downloadOrderInsightsInfo contains DownloadOrderInsightsInfo
   * @returns
   */
  static createMultipleSeparatedColumnsForOrderInsights(
    downloadOrderInsightsInfo: DownloadOrderInsightsEvent,
  ): SeperatedColumn[] {
    const flatMap = arrays => {
      return !!arrays ? [].concat.apply([], arrays) : [];
    };
    let insightTypes = [];
    let productNumbers = [];
    let productDescriptions = [];
    let productBrands = [];
    let packSizes = [];
    let lastOrderedDates = [];
    let casesAndEachesOrdered = [];

    downloadOrderInsightsInfo.insightInformation.forEach(insight => {
      insightTypes.push(insight.orderInsightType || '');
      productNumbers.push(insight.product?.productNumber || '');
      productDescriptions.push(
        `"${insight.product?.summary?.productDescTxtl || ''}"`,
      );
      productBrands.push(`"${insight.product?.summary?.brand || ''}"`);
      packSizes.push(`"${insight.product?.summary?.salesPackSize || ''}"`);
      lastOrderedDates.push(
        `"${
          insight?.lastOrderedDate
            ? DateService.formatDateMaintainUTC(insight.lastOrderedDate)
            : ''
        }"`,
      );
      casesAndEachesOrdered.push(insight?.casesAndEachesOrdered || '');
    });

    const separatedColumns: SeperatedColumn[] = [
      {
        columnName: 'INSIGHT TYPE',
        columnValues: flatMap(insightTypes),
        totals: '',
      },
      {
        columnName: 'PRODUCT #',
        columnValues: flatMap(productNumbers),
        totals: '',
      },
      {
        columnName: 'PRODUCT DESCRIPTION',
        columnValues: flatMap(productDescriptions),
        totals: '',
      },
      {
        columnName: 'BRAND',
        columnValues: flatMap(productBrands),
        totals: '',
      },
      {
        columnName: 'PACK SIZE',
        columnValues: flatMap(packSizes),
        totals: '',
      },
      {
        columnName: 'LAST ORDERED',
        columnValues: flatMap(lastOrderedDates),
        totals: '',
      },
      {
        columnName: 'CS/EA',
        columnValues: flatMap(casesAndEachesOrdered),
        totals: '',
      },
    ];
    return separatedColumns;
  }
}
